import { render, staticRenderFns } from "./CatBrand.vue?vue&type=template&id=da8d22be&scoped=true"
import script from "./CatBrand.vue?vue&type=script&lang=js"
export * from "./CatBrand.vue?vue&type=script&lang=js"
import style0 from "./CatBrand.vue?vue&type=style&index=0&id=da8d22be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8d22be",
  null
  
)

export default component.exports